import PropTypes from 'prop-types';
import FeatherIcon from 'feather-icons-react';
import { Col, Divider, Row } from 'antd';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { ColEvents, DrawerItems, TextInfo } from './modalSelectEvent/style';
import { ContentAppointmentConfirm } from './styled';
import { EventTitle } from './EventTitle';
import { EventActions } from './EventActions';
import { useDictionaryTranslation } from '../../../hooks/useDictionaryTranslation';
import FormExtendedWeb from '../../../views/ServicesHistoryDetails/components/tabs/FormExtendedWeb';
import { finalCustomerSolutionIdRules } from '../../../config/constants/finalCustomerSolutionRuleConstants';
import { getFullName } from '../../../utility/finalCustomerUtils';

export function EventDetailsSummary({
  event,
  showTitle,
  showActions,
  editEvent,
  onCancelEvent,
  confirmService,
  onFinish,
}) {
  const { translate: t } = useDictionaryTranslation();
  const timespan = `${moment(event.start).format('hh:mm A')} - ${moment(event.end).format('hh:mm A')}`;
  const date = `${moment(event.end).format('YYYY-MM-DD')}`;
  const solutionId = useSelector((state) => state.auth?.accountData?.solutionId);
  const finalCustomerSolutionRules = finalCustomerSolutionIdRules[solutionId] ?? finalCustomerSolutionIdRules.default;

  return (
    <>
      <ColEvents xs={24} md={24}>
        <DrawerItems>
          {showTitle ? (
            <>
              <EventTitle event={event} />
              <Divider style={{ marginBottom: '20px' }} className="divider" />
            </>
          ) : null}
          <Row className="contentData">
            <Col md={24} xs={24}>
              <ContentAppointmentConfirm confirm={event.confirmedByUser || event.confirmedByFinalCustomer}>
                <span>
                  {event.confirmedByUser || event.confirmedByFinalCustomer
                    ? t('appointmentConfirm')
                    : t('unconfirmedAppointment')}
                </span>
              </ContentAppointmentConfirm>
            </Col>

            <Col xs={12} md={12} className="event-attr">
              <span className="event-icon">
                <FeatherIcon className="event-attr-icon" icon="server" />
              </span>
              <TextInfo>{t('Tipo')}:</TextInfo>
              <span className="dataText">{event.assignedServiceType}</span>
            </Col>
            <Col xs={12} md={12} className="event-attr">
              <span className="event-icon">
                <FeatherIcon className="event-attr-icon" icon="user" />
              </span>
              <TextInfo className="dataText">{t('finalCustomer')}:</TextInfo>
              <span className="dataText">
                {getFullName(event.assignedFinalCustomer, {
                  useFullName: finalCustomerSolutionRules.showName1,
                })}
              </span>
            </Col>
            <Col xs={12} md={12} className="event-attr">
              <span className="event-icon">
                <FeatherIcon className="event-attr-icon" icon="calendar" />
              </span>
              <TextInfo className="dataText">{t('date')} :</TextInfo>

              <span className="event-date">{date}</span>
            </Col>
            {event.data.infoFinalCustomer != null ? (
              <>
                <Col xs={12} md={12} className="event-attr">
                  <span className="event-icon">
                    <FeatherIcon className="event-attr-icon" icon="credit-card" />
                  </span>
                  <TextInfo>{t('identificationText')}:</TextInfo>
                  <span className="dataText">
                    {event.data.infoFinalCustomer.identificationType} - {event.data.infoFinalCustomer.identification}
                  </span>
                </Col>
                <Col xs={12} md={12} className="event-attr">
                  <span className="event-icon">
                    <FeatherIcon className="event-attr-icon" icon="phone" />
                  </span>
                  <TextInfo>{t('phoneNumber')}:</TextInfo>
                  <span className="dataText">{event.data.infoFinalCustomer?.phone}</span>
                </Col>
                <Col xs={12} md={12} className="event-attr">
                  <span className="event-icon">
                    <FeatherIcon className="event-attr-icon" icon="smartphone" />
                  </span>
                  <TextInfo>{t('mobilePhone')}:</TextInfo>
                  <span className="dataText">{event.data.infoFinalCustomer?.mobilePhone}</span>
                </Col>
              </>
            ) : null}

            <Col xs={12} md={12} className="event-attr">
              <span className="event-icon">
                <FeatherIcon className="event-attr-icon" icon="clock" />
              </span>
              <TextInfo>{t('hour')}:</TextInfo>
              <span className="dataText">{timespan}</span>
            </Col>
            <Col xs={12} md={12} className="event-attr">
              <span className="event-icon">
                <FeatherIcon className="event-attr-icon" icon="airplay" />
              </span>
              <TextInfo>{t('technician')}:</TextInfo>
              <span className="dataText">{event.assignedUser}</span>
            </Col>

            <Col xs={12} md={12} className="event-attr">
              <span className="event-icon">
                <FeatherIcon className="event-attr-icon" icon="home" />
              </span>
              <TextInfo>{t('company')}:</TextInfo>
              <span className="dataText">{event.data?.infoAssignedCompany?.name}</span>
            </Col>
            {event.data?.infoAsset ? (
              <Col xs={12} md={12} className="event-attr">
                <span className="event-icon">
                  <FeatherIcon className="event-attr-icon" icon="info" />
                </span>
                <TextInfo>{t('asset')}:</TextInfo>
                <span className="dataText">{event.data.infoAsset.name}</span>
              </Col>
            ) : null}
            <Col md={24} className="description">
              <TextInfo>{t('description')}:</TextInfo>
              <p className="dataText">{event?.title}</p>
            </Col>
          </Row>
          {event.data?.extendedFormData ? (
            <div style={{ marginTop: '15px' }}>
              <FormExtendedWeb
                data={event?.data}
                columns={2}
                formStyle={{
                  containerMargin: '2px',
                  hidePageIcons: true,
                }}
              />
            </div>
          ) : null}
        </DrawerItems>
        {showActions ? (
          <EventActions
            event={event}
            editEvent={editEvent}
            onCancelEvent={onCancelEvent}
            confirmService={confirmService}
            onFinish={onFinish}
          />
        ) : null}
      </ColEvents>
    </>
  );
}

EventDetailsSummary.propTypes = {
  event: PropTypes.shape({
    idColor: PropTypes.number,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string,
    privateId: PropTypes.string,
    start: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    end: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    assignedUser: PropTypes.string,
    assignedServiceType: PropTypes.string,
    confirmedByFinalCustomer: PropTypes.bool,
    confirmedByUser: PropTypes.bool,
    infoAssignedCompany: PropTypes.string,
    assignedFinalCustomer: PropTypes.object,
    data: PropTypes.object,
    paymentStatus: PropTypes.string,
  }),
  editEvent: PropTypes.func,
  onCancelEvent: PropTypes.func,
  confirmService: PropTypes.func,
  showTitle: PropTypes.bool,
  showActions: PropTypes.bool,
  onFinish: PropTypes.func,
};
